// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
    return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/interopDefault.js
// module id = 87
// module chunks = 0